// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/DetailsActionButton/DetailsActionButton.less
// module id = 1029
// module chunks = 0